import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import { useDispatch, useSelector } from "react-redux";
import { getLifeChallenges, getLifePlan } from "../../redux/actions/APIs";
import { PATHS } from "../../utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getSequnceSort } from "../../utils/helper";
const LifeEvent = ({ setTab }) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const { defaultChildData,
		lifeChallengeData,
	} = useSelector((state) => state.collections);

	const [selecteChalnge, setSelecteChalnge] = useState();


	useEffect(() => {
		if (!lifeChallengeData) {
			dispatch(getLifeChallenges());
		}
		//  setSelecteChalnge();
	}, []);

	const handleOPtion = (value) => {
		setSelecteChalnge(value);
	}

	const showChallengesPlan = () => {
		// setTab("Challenges_Plan");
		// dispatch(getLifePlan(defaultChildData?.id, selecteChalnge))
		history.push({
			pathname: PATHS.MYPLAN_PAGE,
			state: { type: "LifeEvent", getCourseIds: selecteChalnge }
		});
	}


	//  console.log("lifeChallengeData : ", lifeChallengeData);
	return (
		<div className="course_catalogfilstes mb-3">
			<h2>Is Your Child Going Through A Major Life Event? </h2>
			<p className="p2 lighttextcolor mt-3">
				Is your child going through something big—like a move,
				loss, or school change? We’ll Provide A Growth Plan To
				Help Them Navigate This Change. Pick one life event, and
				we’ll guide you to a ready-made plan that helps them
				cope and grow.
			</p>

			<div className="developmentarea">
				<div className="dimtagcontainer">
					<div className="lifeeventlist">
						<ul>
							{lifeChallengeData?.records?.length > 0 &&
								getSequnceSort(lifeChallengeData?.records)?.map((lifeData, index) => (
									<li index={index} className="">
										<div className="Ansoptions">
											<label className="selAnslabel ">
												<p className="p1">{lifeData?.name}</p>
												<input
													type="radio"
													id={"option1"}
													name={"option1"}
													defaultChecked={selecteChalnge === lifeData?.id}
													onChange={() => handleOPtion(lifeData?.id)}
												/>
												<span class="checkmark"></span>
											</label>
										</div>
									</li>
								))}

							{/* <li className="">
                                <div className="Ansoptions">
                                  <label className="selAnslabel ">
                                    <p className="">Death/Loss</p>
                                    <input type="radio" name="knowledgecheck" />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </li>
                              <li className="">
                                <div className="Ansoptions">
                                  <label className="selAnslabel ">
                                    <p className="">Blended Families</p>
                                    <input type="radio" name="knowledgecheck" />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </li>
                              <li className="">
                                <div className="Ansoptions">
                                  <label className="selAnslabel ">
                                    <p className="">Sibling Rivalry</p>
                                    <input type="radio" name="knowledgecheck" />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </li>
                              <li className="">
                                <div className="Ansoptions">
                                  <label className="selAnslabel ">
                                    <p className="">Health Problems</p>
                                    <input type="radio" name="knowledgecheck" />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </li>
                              <li className="">
                                <div className="Ansoptions">
                                  <label className="selAnslabel ">
                                    <p className="">Peer Pressure</p>
                                    <input type="radio" name="knowledgecheck" />
                                    <span class="checkmark"></span>
                                  </label>
                                </div>
                              </li> */}
						</ul>
						<div className="buttonFooter pt-4 mt-3 text-right">
							<button className="mybutton"
								onClick={() => showChallengesPlan()}
								disabled={!selecteChalnge}
							>
							<i className="fa-solid fa-paper-plane mr-1"></i>	Recommend A Growth Plan
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
export default LifeEvent;